import classnames from 'classnames';
import React from 'react';
import { SVGProps } from './SVGProps';

function FacebookExternalLoginSVG({ className, ...rest }: SVGProps) {
	return (
		<svg
			viewBox="0 0 17 32"
			className={classnames('roc-icon roc-icon-facebook-external-login', className)}
			{...rest}
		>
			<path
				fill="#fff"
				style={{ fill: 'var(--color1, #fff)' }}
				d="M16.264 18l0.903-5.791h-5.643v-3.758c0-1.584 0.788-3.129 3.316-3.129h2.566v-4.931c0 0-2.328-0.391-4.554-0.391-4.647 0-7.685 2.774-7.685 7.795v4.414h-5.166v5.791h5.166v14h6.358v-14h4.741z"
			></path>
		</svg>
	);
}

export default FacebookExternalLoginSVG;
